import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
// import TickIcon from "../../../Common/Svgs/TickIcon";
import { updateBatteries } from "../../../Redux/Slices/batteries.slice";
import { updateHome } from "../../../Redux/Slices/home.slice";

// DONT USE IN FAVOR OF ITEMBODY5

const ItemBody7 = ({ notification }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // eslint-disable-next-line no-unused-vars
  const onAssign = () => {
    dispatch(updateHome({ key: "notificationPopupVisible", value: false }));

    dispatch(
      updateBatteries({
        key: "assignPickupAgentModal",
        value: {
          visible: true,
          data: {
            hubId:
              notification?.metaData?.receiverHubId ||
              notification?.metaData?.supplierHubId,
            hubName:
              notification?.metaData?.receiverHubName ||
              notification?.metaData?.supplierHubName,
            receiverHubId:
              notification?.metaData?.receiverHubId ||
              notification?.metaData?.supplierHubId,
            receiverHubName:
              notification?.metaData?.receiverHubName ||
              notification?.metaData?.supplierHubName,
            requestId: notification?.metaData?.requestId,
            supplierHubName: notification?.metaData?.supplierHubName,
            batteryCount: notification?.metaData?.batteryCount,
          },
        },
      }),
    );

    navigate("/batteries");
  };

  return (
    <div>
      {/* <p className="font-poppins text-xs font-light text-black">
        <span className="font-medium text-primary capitalize">
          {notification?.metaData?.supplierHubName}
        </span>
        has <span className="font-medium text-primary">accepted</span> your
        request of {notification?.metaData?.batteryCount} batteries. Please
        assign an agent from your hub to collect the batteries.
      </p>

      <div className="mt-2 w-full flex items-center">
        <button
          type="button"
          className="flex flex-1 items-center justify-center gap-x-2 bg-primary hover:bg-primary-50 py-2 px-4 rounded-md"
          onClick={onAssign}
        >
          <TickIcon size={16} className="text-white" />

          <p className="font-poppins text-xs font-medium text-background-white">
            Assign Pickup Agent
          </p>
        </button>
      </div> */}
    </div>
  );
};

export default ItemBody7;
